export default __webpack_public_path__ + "static/media/03.2a6c6036.png";